export const validDateFormats = [
  'DMMYY',
  'DDMMYY',
  'YYYY-MM-DD HH:mm',
  'YY-MM-DD HH:mm',
  'YYYY-MM-DD',
  'YY-MM-DD',
  'DD-MM-YYYY HH:mm',
  'DD-MM-YY HH:mm',
  'DD-MM-YYYY',
  'DD-MM-YY',
  'D-M-YY',
  'D-M-YYYY',
  'YYYY.MM.DD HH:mm',
  'YY.MM.DD HH:mm',
  'YYYY.MM.DD',
  'YY.MM.DD',
  'DD.MM.YYYY HH:mm',
  'DD.MM.YY HH:mm',
  'DD.MM.YYYY',
  'DD.MM.YY',
  'YYYY/MM/DD HH:mm',
  'YY/MM/DD HH:mm',
  'YYYY/MM/DD',
  'YY/MM/DD',
  'DD/MM/YYYY HH:mm',
  'DD/MM/YY HH:mm',
  'DD/MM/YYYY',
  'DD/MM/YY',
  'D/M/YY HH:mm',
  'D/M/YY',
  'D/M/YYYY HH:mm',
  'D/M/YYYY',
  'MM/DD/YYYY HH:mm',
  'MM/DD/YY HH:mm',
  'MM/DD/YYYY',
  'MM/DD/YY',
  'MM.DD.YYYY HH:mm',
  'MM.DD.YY HH:mm',
  'MM.DD.YYYY',
  'MM.DD.YY',
  'MM-DD-YYYY HH:mm',
  'MM-DD-YY HH:mm',
  'MM-DD-YYYY',
  'MM-DD-YY',
  'DDMMYYYY',
  'YYYYMMDD',
  'YYMMDD',
];
